import jwtDecode from 'jwt-decode';
import {
  AuthActionTypes,
  LOG_IN_REQ,
  LOG_IN_RES,
  LOG_OUT_REQ,
  LOG_OUT_RES,
  LOAD_TOKEN_REQ,
  LOAD_TOKEN_RES,
  FAILED_REQUEST,
} from './types';
import { AppThunk } from '..';
import { LocalAuthModel } from '../../models/localAuthModel';
import { login } from '../../api/authApi';
import { getJwtTokenStorageKey } from '../../config/localStorage';
import { JWTPayloadModel } from '../../models/jwtPayloadModel';

const JWT_TOKEN_STORAGE_NAME = getJwtTokenStorageKey();

function loginInStart(): AuthActionTypes {
  return {
    type: LOG_IN_REQ,
  };
}

function loginInFinish(decodedToken?: JWTPayloadModel): AuthActionTypes {
  return {
    type: LOG_IN_RES,
    payload: decodedToken,
  };
}

function requestError(error: string): AuthActionTypes {
  return {
    type: FAILED_REQUEST,
    payload: error,
  };
}

function logoutStart(): AuthActionTypes {
  return {
    type: LOG_OUT_REQ,
  };
}

function logoutFinish(): AuthActionTypes {
  return {
    type: LOG_OUT_RES,
  };
}

function loadTokenStart(): AuthActionTypes {
  return {
    type: LOAD_TOKEN_REQ,
  };
}

function loadTokenFinish(decodedToken?: JWTPayloadModel): AuthActionTypes {
  if (decodedToken)
    return {
      type: LOAD_TOKEN_RES,
      payload: decodedToken,
    };

  return {
    type: LOAD_TOKEN_RES,
  };
}

export function loadJwt(): AppThunk {
  return function(dispatch) {
    dispatch(loadTokenStart());
    const token = localStorage.getItem(JWT_TOKEN_STORAGE_NAME);
    dispatch(loadTokenFinish(validateToken(token)));
  };
}

export function localLogin(loginData: LocalAuthModel): AppThunk {
  return async function(dispatch) {
    dispatch(loginInStart());

    try {
      const response = await login(loginData.email, loginData.password);
      const { token } = response.data;
      const decodedToken = validateToken(token);

      if (decodedToken) localStorage.setItem(JWT_TOKEN_STORAGE_NAME, token);

      dispatch(loginInFinish(decodedToken));
    } catch (error) {
      dispatch(requestError(error));
    }
  };
}

export function localLogout(): AppThunk {
  return async function(dispatch) {
    dispatch(logoutStart());
    try {
      localStorage.removeItem(JWT_TOKEN_STORAGE_NAME);
      dispatch(logoutFinish());
    } catch (error) {
      dispatch(requestError(error));
    }
  };
}

export function validateToken(token: string | null) {
  if (!token) return undefined;

  const decodedToken = jwtDecode(token) as JWTPayloadModel;
  const dateNow = new Date();

  // Token expired
  if (decodedToken.exp < dateNow.getTime() / 1000) return undefined;

  return decodedToken;
}
